import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'app/store';

const selectMiscState = (state: RootState) => state.misc;

export const selectIsDbooProfileUpdated = createSelector(
  [selectMiscState],
  (miscState) => miscState.isDbooProfileUpdated,
);

export const selectIsWatchlistProfileUpdated = createSelector(
  [selectMiscState],
  (miscState) => miscState.isWatchlistProfileUpdated,
);

export const selectIsDataCollectionModalClosed = createSelector(
  [selectMiscState],
  (miscState) => miscState.isDataCollectionModalClosed,
);
